import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import StudioSessions from './pages/StudioSessions';
import VideoServices from './pages/VideoServices';
import OurWork from './pages/OurWork';
import About from './pages/About';
import AcceptableUse from './pages/AcceptableUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ProductionStandards from './pages/ProductionStandards';
import Lookbook from './pages/Lookbook';
import FAQ from './pages/FAQ';
import MobilePodcast from './pages/MobilePodcast';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Pages with their own top bar — render without site Header/Footer
const STANDALONE_PATHS = ['/lookbook', '/faq', '/mobile-podcast'];

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence
      mode="wait"
      onExitComplete={() => {
        if (window.location.hash) {
          const id = window.location.hash.substring(1);
          const element = document.getElementById(id);
          if (element) element.scrollIntoView({ behavior: 'instant' });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }
      }}
    >
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/studio-sessions" element={<PageWrapper><StudioSessions /></PageWrapper>} />
        <Route path="/video-services" element={<PageWrapper><VideoServices /></PageWrapper>} />
        <Route path="/portfolio" element={<PageWrapper><OurWork /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
        <Route path="/acceptable-use" element={<PageWrapper><AcceptableUse /></PageWrapper>} />
        <Route path="/privacy-policy" element={<PageWrapper><PrivacyPolicy /></PageWrapper>} />
        <Route path="/terms-of-service" element={<PageWrapper><TermsOfService /></PageWrapper>} />
        <Route path="/production-standards" element={<PageWrapper><ProductionStandards /></PageWrapper>} />
        <Route path="/lookbook" element={<PageWrapper><Lookbook /></PageWrapper>} />
        <Route path="/faq" element={<PageWrapper><FAQ /></PageWrapper>} />
        <Route path="/mobile-podcast" element={<PageWrapper><MobilePodcast /></PageWrapper>} />
        <Route path="*" element={<PageWrapper><Home /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppShell />
    </Router>
  );
}

function AppShell() {
  const location = useLocation();
  const isStandalone = STANDALONE_PATHS.includes(location.pathname);

  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#000000] font-sans selection:bg-black selection:text-white flex flex-col">
      {!isStandalone && <Header />}
      <div className={isStandalone ? '' : 'flex-grow'}>
        <AnimatedRoutes />
      </div>
      {!isStandalone && <Footer />}
    </div>
  );
}

export default App;